var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9443 20.4638H23.4586C26.2707 20.4638 26.4533 22.4603 26.4533 22.4603L14.7091 26.9773C14.3205 27.1267 13.9051 27.1935 13.4894 27.1734C13.0736 27.1533 12.6666 27.0467 12.2943 26.8605L5.49031 23.4585V16.4708H6.48855C7.5916 16.4708 10.3877 16.9081 11.4797 18.4673H14.4745C15.5335 18.4673 16.5491 18.888 17.2979 19.6368C18.0467 20.3856 18.4674 21.4013 18.4674 22.4603H11.4797",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31033 13.7068C9.16733 11.8456 10.6348 10.3333 12.4693 9.42063C14.3039 8.50798 16.3953 8.24985 18.3967 8.68905C20.3981 9.12825 22.1892 10.2384 23.473 11.8353C24.7568 13.4323 25.4562 15.4201 25.4551 17.4692",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4657 17.4691H27.4516",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4709 5.49023V8.48495",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9577,
    height: 23.9577,
    fill: "white",
    transform: "translate(3.99295 3.99292)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/Services.23a9891e7fd9ab6abcdb51915dd123b0.svg";
export { ForwardRef as ReactComponent };